module.exports = __webpack_public_path__ + "static/media/ok.e9706dc3.png";